import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, map } from 'lodash';

import ContentWrapper from 'components/ContentWrapper';
import User from 'assets/images/pending.svg';
import {
  newNextAction,
  NEW_NEXT,
} from '../../actions/navigation';
import Container from '../../components/Container';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Button from '../../components/Button';
import Radio from '../../components/Form/Radio';
import { useConfig } from '../../config/ConfigContext';
import Header from '../../components/Header';
import ApplicationId from '../../components/ApplicationId';
import './style.scss';

const Questions = (props) => {
  const config = useConfig();
  const { checkinData, location, params, searchParams } = props;
  const [request, setRequest] = useState({});
  const [isAllFilled, setIsAllFilled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const questions = useMemo(() => get(checkinData, 'data.questions'), [checkinData]);
  const attempt = useMemo(() => get(checkinData, 'data.attempt'), [checkinData]);
  const key = searchParams.get('key');

  const initializeRequest = (checkinDataArg) => {
    const { questions: questionsArg, conversationId, questionSetId } = get(checkinDataArg, 'data');
    const answers = (questionsArg || []).map((q) => {
      const { questionId } = q;
      return {
        QuestionId: questionId,
        ChoiceId: null,
      };
    });
    request.Answers = answers;
    setRequest({
      ConversationId: conversationId,
      QuestionSetId: questionSetId,
      Answers: answers,
    });
  };

  useEffect(() => {
    const { navigate } = props;
    const test = searchParams.get('test');
    const workflowType = get(params, 'workflowType');

    if (get(checkinData, ['data']) === undefined) {
      if (test) {
        navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}&test=${test}`);
      } else {
        navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
      }
    } else if (get(checkinData, 'data.questions')) {
      initializeRequest(checkinData);
    }
  }, []);

  useEffect(() => {
    const { fetch, navigate } = props;
    // initializeRequest(checkinData);
    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(routeUrl);
    }
  }, [checkinData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleChange = (event, choiceId) => {
    const { Answers } = request;
    let answersToUpdate = map(Answers, (answer) => answer);
    answersToUpdate = answersToUpdate.map((answer) => {
      if (answer.QuestionId === event.target.name) {
        return {
          ...answer,
          ChoiceId: choiceId,
        };
      }
      return answer;
    });
    const emptyAnswers = answersToUpdate.filter((answer) => answer.ChoiceId === null) || [];
    if (Array.isArray(emptyAnswers) && emptyAnswers.length === 0) {
      setIsAllFilled(true);
    }
    setRequest({
      ...request,
      Answers: answersToUpdate,
    });
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    if (!isAllFilled) setIsValid(false);
    else setIsValid(true);

    const workflowType = get(params, 'workflowType') || 'text2apply';

    if (key && isAllFilled) {
      setIsLoading(true);
      props.dispatch(newNextAction({
        data: request,
        key,
        workflowType,
        success: (response) => {
          const routeUrl = response.data && response.data.url;
          setIsAllFilled(false);
          setIsLoading(false);
          const newCheckinData = response.data.questions && response;
          if (newCheckinData) initializeRequest(newCheckinData);
          props.navigate(routeUrl);
        },
        fail: (error) => {
          setIsAllFilled(false);
          setIsLoading(false);
          props.navigate({
            pathname: '/results/denied',
            search: '',
            state: {
              data: error.data,
            },
          });
        },
      }));
    }
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      <ContentWrapper className="content appIdVisible" style={{ padding: '10px 20px' }}>
        <Container className="container">
          <FormRow>
            <FormColumn>
              <h2 className="text-left heading-h">Identity Verification</h2>
              <div className="d-flex align-items-center">
                <img src={User} alt="User Icon" className="user-image" />
                <div className="pl-10">
                  <div>LendingUSA</div>
                </div>
              </div>
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn>
              {!isLoading
                && attempt === 2 && (
                <div className="pt-10">
                  <p className="form-note text-left">Sorry, we were unable to confirm your identity. Please try again.</p>
                </div>
              )}
              <h4 className="pt-20 text-left">ID Check - Identification Questions</h4>
              <p className="heading-paragraph pt-10 text-left">Please respond to the questions below so that we may verify your identity. Once your identity has been verified, you&#39;ll be able to sign your loan documents.</p>
            </FormColumn>
          </FormRow>
          <FormColumn className="pt-10">
            {questions
              && questions.map((q) => {
                const { choices, question, questionId } = q;
                return (
                  <div className="pt-10" key={questionId}>
                    <FormRow>
                      <strong className="text-left">{question}</strong>
                    </FormRow>
                    <FormColumn className="pt-10">
                      {
                        choices.map((c) => (
                          <FormRow>
                            <div key={c.choiceId}>
                              <div className="d-flex align-items-center radio-element text-left">
                                <Radio value="Answer1" name={questionId} onChange={(e) => handleChange(e, c.choiceId)} label={c.choice} />
                              </div>
                            </div>
                          </FormRow>
                        ))
                      }
                    </FormColumn>
                  </div>
                );
              })}
            {!isValid && (
              <div className="pt-10">
                <p className="form-note">Please answer all of the questions provided.</p>
              </div>
            )}
          </FormColumn>
        </Container>
      </ContentWrapper>
      <div className="footer" style={{ paddingBottom: 20 }}>
        <FormRow>
          <FormColumn>
            <Button
              color="primary"
              className="large buttonStyle btn-primary"
              onClick={handleSubmitForm}
              isLoading={isLoading}
              isDisabled={isLoading || (request && request.Answers && request.Answers.filter((q) => q.ChoiceId).length !== questions.length)}
              title="Submit"
            />
          </FormColumn>
        </FormRow>
      </div>
    </div>
  );
};

Questions.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Questions);
